// libraries
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Tabs } from 'antd';

// resources
import { txt } from '../../../locales/i18n';

import { SproglandVolunteersTab } from './tabs/sprogland-volunteers-tab';
import { SproglandSessionsTab } from './tabs/sprogland-sessions-tab';
import { SproglandJuniorSessionsTab } from './tabs/sprogland-junior-sessions-tab';

import { SnakSammenSessionsTab } from './tabs/snaksammen-sessions-tab';
import { SnakSammenVolunteersTab } from './tabs/snaksammen-volunteers-tab';

export function RedCross(): JSX.Element {
	const [activeTab, setActiveTab] = useState<string>('#sprogland-volunteers');
	const [rkAccess, setRkAccess] = useState<string[]>([]);
	const history = useHistory();
	const location = useLocation();

	useEffect(() => setActiveTab(location.hash), [location.hash]);
	useEffect(() => setRkAccess(JSON.parse(localStorage.getItem('bb_rk_access') ?? '[]')), []);
	useEffect(() => {
		if (rkAccess.includes('*') || rkAccess.includes('sprogland')) {
			history.replace({ hash: '#sprogland-volunteers' });
			return;
		}

		if (rkAccess.includes('snaksammen')) {
			history.replace({ hash: '#snaksammen-volunteers' });
			return;
		}
	}, [rkAccess, history]);

	return (
		<StyledRedCross>
			<Tabs centered activeKey={activeTab} onChange={(hash) => history.push({ hash })} destroyInactiveTabPane>
				{(rkAccess.includes('*') || rkAccess.includes('sprogland')) && (
					<>
						<Tabs.TabPane
							tab={`Sprogland ${txt('red-cross.volunteers')}`}
							key="#sprogland-volunteers"
							forceRender
						>
							<SproglandVolunteersTab />
						</Tabs.TabPane>

						<Tabs.TabPane tab="Sprogland sessions" key="#sprogland-session">
							<SproglandSessionsTab />
						</Tabs.TabPane>

						<Tabs.TabPane tab="Sprogland junior sessions" key="#sprogland-junior-session">
							<SproglandJuniorSessionsTab />
						</Tabs.TabPane>
					</>
				)}

				{(rkAccess.includes('*') || rkAccess.includes('snaksammen')) && (
					<>
						<Tabs.TabPane tab={`SnakSammen ${txt('red-cross.volunteers')}`} key="#snaksammen-volunteers">
							<SnakSammenVolunteersTab />
						</Tabs.TabPane>

						<Tabs.TabPane tab="SnakSammen sessions" key="#snaksammen-session">
							<SnakSammenSessionsTab />
						</Tabs.TabPane>
					</>
				)}
			</Tabs>
		</StyledRedCross>
	);
}

const StyledRedCross = styled.main`
	display: flex;
	flex-direction: column;

	.ant-tabs,
	.ant-tabs-content,
	.ant-tabs-content > div {
		display: contents;
	}

	.ant-tabs-content-holder {
		flex: 1;
	}
`;
